import autosize from 'autosize'
import {
    type RefCallback,
    useEffect,
    useRef,
} from 'react'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'

interface UseAutogrowOnTextAreaOptions {
    value?: string
    resetHeightOnEmptyValue?: boolean
}

interface UseAutogrowOnTextAreaReturn {
    // RefCallback для передачи в атрибут ref текстового поля ввода.
    inputRefHandler: RefCallback<HTMLTextAreaElement>
    // Элемент текстового поля ввода.
    inputElement: HTMLTextAreaElement | null
    // Обновление высоты текстового поля ввода.
    update: () => void
}

// Инициализация автоматического увеличения высоты текстовых полей ввода с CSS классом 'autogrow'.
// Возвращает RefCallback, который нужно передать в атрибут ref текстового поля ввода.
export function useAutogrowOnTextArea(
    options: UseAutogrowOnTextAreaOptions = {}
): UseAutogrowOnTextAreaReturn {

    const {
        value,
        resetHeightOnEmptyValue = true,
    } = options

    // Ссылка на элемент текстового поля ввода.
    const commentTextareaRef = useRef<HTMLTextAreaElement | null>(null)

    // Сброс высоты поля ввода, когда нет текста сообщения.
    useEffect(() => {
        if (value === '' && resetHeightOnEmptyValue) {
            commentTextareaRef.current?.style.removeProperty('height')
        }
    }, [value, resetHeightOnEmptyValue])

    // Обработчик изменения ссылки на элемент текстового поля ввода.
    const handleRef = useEventCallback((
        element: HTMLTextAreaElement | null
    ) => {
        commentTextareaRef.current = element
        if (element) {
            autosize(element)
        }
    })

    // Обновление высоты текстового поля ввода.
    const update = useEventCallback(() => {
        if (!commentTextareaRef.current) {
            return
        }
        autosize.update(commentTextareaRef.current)
    })

    return {
        inputRefHandler: handleRef,
        inputElement: commentTextareaRef.current,
        update,
    }
}
